import { createFileRoute } from "@tanstack/react-router";
import International from "@/pages/services/International";

export const Route = createFileRoute("/services/international")({ component: International });